<template>
	<section class="portal-filter-bar" :aria-label="label">
		<div class="filter-controls">
			<slot></slot>
		</div>
		<div class="filter-summary" v-if="$slots.summary || $scopedSlots.summary">
			<slot name="summary"></slot>
		</div>
	</section>
</template>

<script>
	export default {
		name: 'PortalFilterBar',

		props: {
			label: { type: String, required: true },
		},
	};
</script>

<style scoped lang="scss">
	.portal-filter-bar {
		display: flex;
		align-items: center;
		gap: 12px;
		min-height: 42px;
	}

	.filter-controls {
		min-width: 0;
		flex: 1;
		display: flex;
		align-items: center;
		gap: 10px;
		flex-wrap: wrap;
	}

	.filter-summary {
		flex: 0 0 auto;
		color: var(--portal-muted);
		font-size: 13px;
	}

	@media (max-width: 760px) {
		.portal-filter-bar {
			align-items: flex-start;
		}

		.filter-summary {
			display: none;
		}
	}

	@media (max-width: 599px) {
		.portal-filter-bar {
			gap: 8px;
		}

		.filter-controls {
			display: grid;
			grid-template-columns: minmax(0, 1fr);
		}
	}
</style>
